// extracted by mini-css-extract-plugin
export default {"modalContent":"ModalProposalImage_modalContent__rq3Wz"};